import AbstractService from '@/services/abstractService'

class RepresentativesService extends AbstractService {
    endpoint = 'representatives'

    index() {
      return this.http.get(this.endpoint, { params: { dashboard: true } })
    }

    post(data) {
      console.log('data', data)
      // define append form
      const formData = new FormData()
      for (const key in data) {
        formData.append(key, data[key])
      }
      return this.http.post(this.endpoint, formData)
    }

    put(data) {
      console.log('data', data)
      // define append form
      const formData = new FormData()

      for (const key in data) {
        formData.append(key, data[key])
      }
      return this.http.put(`${this.endpoint}/${data.id}`, formData)
    }

    delete(data) {
      console.log('data', data)
      return this.http.delete(`${this.endpoint}/${data}`)
    }

    changeRole(id) {
      return this.http.post(`${this.endpoint}/${id}/role`)
    }

    changePassword(data) {
        const formData = new FormData()
        for (const key in data) {
            formData.append(key, data[key])
        }
        return this.http.post(`${this.endpoint}/${data.id}/changePassword`, formData)
    }
}

const Service = new RepresentativesService()

export default Service
